import { Injectable, inject } from '@angular/core';
import { map } from 'rxjs';
import { UrlService } from '../state/url.service';

@Injectable({
  providedIn: 'root'
})
export class ErweiterteSucheService {
  private readonly urlService = inject(UrlService);

  public static readonly URL_PARAM = 'erws';

  public erweiterteSucheActive$ = this.urlService
    .getQueryParameterValue(ErweiterteSucheService.URL_PARAM)
    .pipe(map((value) => value === 'true'));

  public setAktiv(aktiv: boolean): void {
    this.urlService.updateUrlQueryParams({ [ErweiterteSucheService.URL_PARAM]: aktiv });
  }
}
